
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/channels/[slug]",
      function () {
        return require("private-next-pages/channels/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/channels/[slug]"])
      });
    }
  